import React from 'react';
import clsx from 'clsx';
import ToastWrapper from './ToastWrapper';

const NegativeToast = ({
  children,
  className,
  icon = 'check circle',
}) => (
  <ToastWrapper
    className={clsx('aridhia-negative-toast toast-message', className)}
    color="red"
    icon={icon}
  >
    {children}
  </ToastWrapper>
);

export default NegativeToast;
